import React, { useState } from 'react'
import { Button, Checkbox, Input, Menu, MenuHandler, MenuItem, MenuList, Typography } from '@material-tailwind/react'
import { FaChevronDown } from 'react-icons/fa'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'
import { setSelectedOptions, setRange, setFilterDate, setCurrentPage, setFilterDropdown } from '../../reducers/contextSlice'
import { useDispatch } from 'react-redux'


export const Dropdowns = ({ Icon, title, name, dropData, download = false, dateTime = false }) => {

    const dispatch = useDispatch();
    const { selectedOptions, range, filterDate, filterDropdown } = useSelector(state => state.context)
    const handleRange = (e) => dispatch(setRange({ ...range, [e.target.name]: e.target.value }))
    const handleFilterDate = (e) => dispatch(setFilterDate(e.target.value));
    const handleSubmitFilter = () => {
        if (range.min || range.max) {
            if (!range.min || !range.max || range.min < range.max || range.min !== range.max) {
                dispatch(setFilterDropdown({ ...filterDropdown, ...range }))
            } else {
                toast.error(`Invalid Range!`)
            }
        }
        if (filterDate) {
            dispatch(setFilterDropdown({ ...filterDropdown, filterDate }))
        }
    }

    const [searchTerm, setSearchTerm] = useState('');

    const handleSearchTermChange = (e) => {
        e.preventDefault()
        setSearchTerm(e.target.value);
    }

    const handleOptionClick = (e, _optionId) => {
        dispatch(setCurrentPage(1));
        const isSelected = filterDropdown[name]?.includes(_optionId);
        if (isSelected) {
            let selectedOptionsFilter = filterDropdown[name].filter((o) => o !== _optionId);
            dispatch(setSelectedOptions(selectedOptionsFilter));
            if (selectedOptionsFilter.length > 0) {
                dispatch(setFilterDropdown({ ...filterDropdown, [e.target.name]: selectedOptionsFilter }))
            } else {
                const updatedFilterDropdown = { ...filterDropdown };
                delete updatedFilterDropdown[e.target.name];
                dispatch(setFilterDropdown({ ...updatedFilterDropdown }))
            }
        } else {
            let oldData = (!download && !dateTime) && (filterDropdown[name] || []);
            let newAry = [...oldData, _optionId];
            dispatch(setSelectedOptions(newAry));
            dispatch(setFilterDropdown({ ...filterDropdown, [e.target.name]: newAry }))
        }
    };

    const filteredOptions = dropData && dropData.filter((_option) => _option?.label?.toLowerCase().includes(searchTerm.toLowerCase()));

    function close() {
        let el = document.getElementById("filterDate");
        if (el) { el.blur() }
    }

    return (
        <div className='bypass-timeout'>
            <Menu placement='bottom-start' dismiss={{ itemPress: false, isRequired: {} }}>
                <MenuHandler>
                    <Button variant='filled' color='white' className='text-ink-blue hover:shadow-none shadow-none border border-edge-mid bg-gray-100 flex items-center px-2.5 lg:px-2'>
                        <div className='flex mr-2 md:mr-[25px] lg:mr-1 2xl:mr-[25px] items-center'>
                            <Icon className='text-[14px] md:text-[18px] 2xl:text-[22px]' />
                            <span className='ml-2.5 text-[14px] md:text-[16px] lg:text-[14px] 2xl:text-[16px] capitalize font-normal'>
                                {title}
                                {(!download && !dateTime) && filterDropdown[name]?.length > 0 && ` : ${filterDropdown[name].length}`}
                            </span>
                        </div>
                        <FaChevronDown className='text-[14px] md:text-[16px] lg:text-[12px] 2xl:text-[16px]' />
                    </Button>
                </MenuHandler>
                <MenuList className='border-edge-mid min-w-[140px] lg:min-w-[180px] max-h-80 overflow-y-auto'>
                    {
                        download &&
                        <>
                            <Typography className="text-[18px] font-normal text-ink-blue leading-none focus-visible:outline-0">{`Type Number`}</Typography>
                            <div className='flex items-center my-2.5'>
                                <Input label="Min" name='min' type='number' containerProps={{ className: "!w-[80px] !min-w-[70px]" }} value={range.min} onChange={handleRange} />
                                <Typography className='font-normal text-[#151515] p-2.5'>To</Typography>
                                <Input label="Max" name='max' type='number' containerProps={{ className: "!w-[80px] !min-w-[70px]" }} value={range.max} onChange={handleRange} />
                            </div>
                            <Button className="px-5 py-3 bg-primary shadow-none text-white font-medium border border-primary hover:shadow-none capitalize text-sm w-full leading-none" type='button' onClick={handleSubmitFilter}>Go</Button>
                        </>
                    }{
                        dateTime &&
                        <span className='add-edit-form'>
                            <Input id="filterDate" name='filterDate' type='datetime-local' value={filterDate} onChange={handleFilterDate} onInput={close} />
                            <Button className="mt-2.5 px-5 py-3 bg-primary shadow-none text-white font-medium border border-primary hover:shadow-none capitalize text-sm w-full leading-none" type='button' onClick={handleSubmitFilter}>Go</Button>
                        </span>
                    }{
                        (!download && !dateTime) &&
                        <>
                            <Input label="Search" className='bypass-timeout' containerProps={{ className: "mb-4", }} value={searchTerm} onChange={handleSearchTermChange} />

                            {filteredOptions && filteredOptions?.map((_ele) => (
                                <MenuItem className="p-0 bypass-timeout" key={_ele.id || _ele.label}>
                                    <label
                                        htmlFor={_ele.id}
                                        className="flex cursor-pointer items-center gap-2 p-2 bypass-timeout "
                                    >
                                        <Checkbox
                                            name={name}
                                            ripple={false}
                                            id={_ele.id}
                                            containerProps={{ className: "p-0" }}
                                            className="hover:before:content-none checked:bg-primary checked:border-primary bypass-timeout"
                                            checked={filterDropdown[name]?.includes(_ele.id || _ele.label?.toLowerCase())}
                                            onClick={(e) => handleOptionClick(e, _ele.id || _ele.label?.toLowerCase())}
                                        />
                                        {_ele.label}
                                    </label>
                                </MenuItem>
                            ))}
                            {filteredOptions?.length === 0 && (
                                <div className="px-4 py-2 text-sm text-gray-500">No options found.</div>
                            )}
                        </>
                    }
                </MenuList>
            </Menu >
        </div>
    )
}

export default Dropdowns
